import React from 'react'
import { Box } from '@mui/material'


const cellStyle = {
  verticalAlign: 'bottom',
  borderLeft: '1px solid #ccc',
}

const contentStyle = {
  height: 4,
  width: '100%',
  background: 'transparent',
}

const PseudoBorderLine = () => (
  <tr>
    <th>
      <Box sx={contentStyle} />
    </th>
    <td colSpan='2'>
      <Box sx={contentStyle} />
    </td>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' sx={cellStyle} colSpan='4'>
      <Box sx={contentStyle} />
    </Box>
    <Box component='td' colSpan='2'>
      <Box sx={contentStyle} />
    </Box>
  </tr>
)

export default PseudoBorderLine
